import React, { useState } from "react";
import { Dropdown } from "primereact/dropdown";

const SingleSelect = ({
  value,
  handleSingleSelectChange,
  options,
  className = "",
  error = null,
  placeholder = "Select option",
  disabled = false,
  panelClassName = "",
  label = null,
  required = null,
  readOnlyInput = false,
}) => {
  return (
    <div className="d-block">
      {label && (
        <label>
          {label}
          {required && <span className="text-danger">*</span>}
        </label>
      )}
      <Dropdown
        value={value}
        readOnlyInput={readOnlyInput}
        onChange={handleSingleSelectChange}
        options={options}
        optionLabel="name"
        placeholder={placeholder}
        className={`single_dropdown w-100 ${className}`}
        disabled={disabled}
        panelClassName={panelClassName}
      />
      {error && <div className="text-danger">{error}</div>}
    </div>
  );
};

export default SingleSelect;
